import * as angular from 'angular';
import { DirectiveDefinition } from './directiveDefinition';

class WtAutoTitleController implements angular.IController {
    static $inject = ['$scope', '$element'];

    constructor(private _$scope: angular.IScope,
        private _$element: angular.IAugmentedJQuery) {
    }

    $onInit() {        
        const handle = setTimeout(() => {
            let title = this._$element.text();
            if (title) {
                title = title.trim();
            }
            this._$element.attr('title', title);
        });
        this._$scope.$on('$destroy', () => clearTimeout(handle));
    }
}

export const WtAutoTitleDirective: DirectiveDefinition = {
    directiveId: 'wtAutoTitle',
    restrict: 'A',
    controller: WtAutoTitleController,
};